var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2157,
    height: 2157,
    viewBox: "0 0 2157 2157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M614.732 1501.3C573.017 1455.58 538.294 1403.95 511.689 1348.08L1078.29 1078.29L614.732 1501.3Z",
    fill: "#F8976C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M511.654 1348C485.057 1292.12 466.871 1232.62 457.688 1171.41L1078.29 1078.29L511.654 1348Z",
    fill: "#F8976C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M457.361 1169.21C448.395 1107.98 448.536 1045.75 457.78 984.56L1078.29 1078.29L457.361 1169.21Z",
    fill: "#F8976C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M457.69 985.158C466.874 923.956 485.061 864.45 511.66 808.572L1078.29 1078.29L457.69 985.158Z",
    fill: "#F8976C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M512.184 807.475C538.89 751.647 573.708 700.078 615.507 654.44L1078.29 1078.29L512.184 807.475Z",
    fill: "#F8976C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M616.293 653.583C658.176 608.023 706.568 568.908 759.898 537.509L1078.29 1078.29L616.293 653.583Z",
    fill: "#F8976C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M932.356 467.945C992.545 453.553 1054.53 448.144 1116.31 451.893L1078.29 1078.29L932.356 467.945Z",
    fill: "#F8976C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1283.72 485.317C1342.2 505.576 1397.36 534.373 1447.41 570.773L1078.29 1078.29L1283.72 485.317Z",
    fill: "#F8976C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1575.36 695.216C1613.14 744.235 1643.45 798.572 1665.33 856.463L1078.29 1078.29L1575.36 695.216Z",
    fill: "#F8976C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1703.65 1025.82C1708.82 1087.49 1704.85 1149.58 1691.85 1210.09L1078.29 1078.29L1703.65 1025.82Z",
    fill: "#F8976C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1627.36 1382.18C1597.39 1436.33 1559.58 1485.74 1515.15 1528.82L1078.29 1078.29L1627.36 1382.18Z",
    fill: "#F8976C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1373.35 1632.15C1318.74 1661.25 1260.11 1682.11 1199.39 1694.05L1078.29 1078.29L1373.35 1632.15Z",
    fill: "#F8976C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1049.62 1705.19C987.794 1702.36 926.731 1690.4 868.408 1669.71L1078.29 1078.29L1049.62 1705.19Z",
    fill: "#F8976C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M759.629 537.668C812.943 506.243 870.612 482.876 930.764 468.328L1078.29 1078.29L759.629 537.668Z",
    fill: "#F8976C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1106.97 451.396C1168.79 454.224 1229.85 466.181 1288.18 486.879L1078.29 1078.29L1106.97 451.396Z",
    fill: "#F8976C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1445.53 569.414C1495.72 605.63 1540.27 649.07 1577.74 698.323L1078.29 1078.29L1445.53 569.414Z",
    fill: "#F8976C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1662.22 848.401C1684.89 905.986 1698.92 966.607 1703.85 1028.3L1078.29 1078.29L1662.22 848.401Z",
    fill: "#F8976C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1691.94 1209.65C1678.99 1270.16 1657.16 1328.43 1627.15 1382.56L1078.29 1078.29L1691.94 1209.65Z",
    fill: "#F8976C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1519.64 1524.43C1475.64 1567.95 1425.45 1604.73 1370.69 1633.56L1078.29 1078.29L1519.64 1524.43Z",
    fill: "#F8976C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1196.86 1694.54C1136.09 1706.24 1073.92 1708.87 1012.38 1702.37L1078.29 1078.29L1196.86 1694.54Z",
    fill: "#F8976C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M904.43 1681.28C844.966 1664.13 788.365 1638.29 736.464 1604.58L1078.29 1078.29L904.43 1681.28Z",
    fill: "#F8976C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M757.022 1617.37C703.86 1585.69 655.677 1546.32 614.037 1500.54L1078.29 1078.29L757.022 1617.37Z",
    fill: "#F8976C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinning);
export default __webpack_public_path__ + "static/media/spinning.fe2b9b7ed304634c65fb744fde1951e3.svg";
export { ForwardRef as ReactComponent };